import { ADD_CLOTH_RETURN, CLOTH_RETURN_HISTORY } from "../Action/clothReturn";

const initialState = {
  clothReturns: [],
  clothReturnHis: [],
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_CLOTH_RETURN: {
      return {
        ...state,
        clothReturns: [action.payload, ...state.clothReturns],
      };
    }
    case CLOTH_RETURN_HISTORY: {
      const payload = action.payload;
      return {
        ...state,
        clothReturnHis: Array.isArray(payload)
          ? payload
          : payload?.result || [],
      };
    }
    default:
      return state;
  }
}

export default accountReducer;
